import { useMemo, useState } from "react";
import { Vehicle } from "../../../api/vehiclesApi";

interface UseVehicleFilterProps {
  vehicles: Vehicle[];
}

interface UseVehicleFilterResult {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  filteredVehicles: Vehicle[];
}

export const useVehicleFilter = ({
  vehicles,
}: UseVehicleFilterProps): UseVehicleFilterResult => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredVehicles = useMemo(() => {
    if (!searchQuery) return vehicles;

    const query = searchQuery.toLowerCase();
    return vehicles.filter(
      (vehicle) =>
        vehicle.name.toLowerCase().includes(query) ||
        (vehicle.type?.toLowerCase().includes(query) ?? false) ||
        (vehicle.registrationNumber?.toLowerCase().includes(query) ?? false) ||
        (vehicle.make?.toLowerCase().includes(query) ?? false) ||
        (vehicle.model?.toLowerCase().includes(query) ?? false)
    );
  }, [vehicles, searchQuery]);

  return {
    searchQuery,
    setSearchQuery,
    filteredVehicles,
  };
};
